import React from "react";
import "./premiumFeature.css"; 
import PremiumFeaturePage from "./premiumFeaturePage";
import { useNavigate } from "react-router-dom";

const PremiumFeature = () => {
  const navigate = useNavigate();

  const handleSubscribe = () => {
    // console.log("Button Clicked!"); 
    navigate("/subscriptions"); 
  };

  return (
    <PremiumFeaturePage>
      <div className="premium-container">
        <div className="premium-card">
          <div className="premium-icon">
            <h3 className="premium-subtitle">You've discovered a</h3>
            <h2 className="premium-title">Premium Feature</h2>

            <p className="premium-description">
              To unlock all benefits of Open Curtains Casting, please subscribe.
            </p>
            <button onClick={handleSubscribe} className="subscribe-button">
              SUBSCRIBE
            </button>
          </div>
        </div>
      </div>
    </PremiumFeaturePage>
  );
};

export default PremiumFeature;
